import { createStore } from 'vuex'
import header from 'src/store/home-page/header/header'
import auth from 'src/store/user/auth.js'
import userMessages from 'src/store/user/profile/messages'
import bonuses from 'src/store/user/profile/bonuses.js'
import system from 'src/store/system/system.js'
import games from 'src/store/games.js'
import ssr from 'src/store/ssr/ssr'
import siteInfo from 'src/store/site-info/site-info'
import modals from './modals'
import betting from './betting'
import results from 'src/store/betting/results'
import categories from './categories'
import promotedBonusModule from './promoted-bonus-module'
import manufacturers from './manufacturers.js'
import payment from './payment/index.js'
import promo from './promo/index.js'
import platformConfig from 'src/platform-config.js'
import { i18nObject } from 'src/boot/i18n'

const config = platformConfig.configs(process.env.PLATFORM)

export default function () {
  return createStore({
    state: () => ({
      info: {},
      appConfig: {
        titlePure: config.title,
        name: config.shortTitle,
        addressBarColor: config.addressBarColor,
        links: {
          baseLink: config.links.baseLink,
          support: config.links.support,
          help: config.links.help,
        },
        meta: config.meta,
        mainGroups: [],
      },
    }),
    mutations: {
      UPDATE_APP_CONFIG(state, value) {
        state.appConfig = value
      },
      UPDATE_MAIN_GROUPS(state) {
        state.mainGroups = [
          {
            slug: 'slot',
            label: i18nObject.global.t('slots'),
            name: 'GamesByGroup',
          },
          {
            slug: 'online',
            label: i18nObject.global.t('live_casino'),
            name: 'GamesByGroup',
          },
          {
            slug: 'fast',
            label: i18nObject.global.t('instant'),
            name: 'GamesByGroup',
          },
          {
            slug: 'table',
            label: i18nObject.global.t('table'),
            name: 'GamesByGroup',
          },
          {
            slug: 'lottery',
            label: i18nObject.global.t('lottery'),
            name: 'GamesByGroup',
          },
          {
            slug: 'vsport',
            label: i18nObject.global.t('virtuals'),
            name: 'GamesByGroup',
          },
        ]
      },
      UPDATE_INFO_KEY(state, value) {
        state.info = { ...state.info, ...value }
      },
      REMOVE_INFO_KEY(state, key) {
        const data = { ...state.info }
        delete data[key]
        state.info = data
      },
    },
    getters: {
      getAppConfig: (s) => s.appConfig,
      getHomeMeta: (s) => s.appConfig.meta.home,
      getMainGroups: (s) => s.mainGroups,
      getInfoItem: (s) => (key) => s.info?.[key],
    },
    modules: {
      header,
      auth,
      games,
      userMessages,
      bonuses,
      system,
      siteInfo,
      ssr,
      modals,
      betting,
      categories,
      results,
      manufacturers,
      promotedBonusModule,
      payment,
      promo,
    },
    strict: process.env.DEBUGGING,
  })
}
